enum TransactionType {
  normal,
  refund
}

export default TransactionType
